<ng-container *ngIf="message$ | async as message">
  <div *ngFor="let message of alerts; let i = index">
    <div
      *ngIf="
        message.type === 'warning' || message.type === 'error';
        else showToaster
      "
      [ngClass]="{
        alert: message.text,
        'alert-warning': message.type === 'warning',
        'alert-danger': message.type === 'error'
      }"
    >
      <i *ngIf="message.type === 'warning'" class="material-icons alert-icon">
        warning
      </i>
      <i *ngIf="message.type === 'error'" class="material-icons alert-icon">
        error
      </i>
      <div>{{ message?.text }}</div>
      <button
        type="button"
        class="close"
        (click)="closeAlert(i)"
        *ngIf="message.canDismiss === true"
      >
        <i class="modus-icon material-icons">close</i>
      </button>
    </div>
  </div>
</ng-container>
<ng-template #showToaster>
  <ng-container *ngIf="message$ | async as message">
    <div *ngIf="message?.text" class="toast toast-success show">
      {{ message?.text }}
      <button
        type="button"
        class="close"
        data-dismiss="toast"
        aria-hidden="true"
        (click)="closeAlert(i)"
      >
        <i class="modus-icon material-icons">close</i>
      </button>
    </div>
  </ng-container>
</ng-template>
